"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CONNECTORS = exports.createSearchUrl = exports["default"] = void 0;
var CONNECTORS = {
  AND: "and",
  OR: "or"
};
exports.CONNECTORS = CONNECTORS;
var createSearchUrl = function createSearchUrl(url, params) {
  return url + params.map(function (param, index, array) {
    var searchQuery = "";
    var ampersand = array.length === 1 || index <= 0 ? "?" : "&";
    var filtersGroupIndex = param.connector === CONNECTORS.AND ? index : 0;
    var filtersIndex = param.connector === CONNECTORS.OR ? index : 0;
    if (param.field) {
      searchQuery += "".concat(ampersand, "searchCriteria[filter_groups][").concat(filtersGroupIndex, "][filters][").concat(filtersIndex, "][field]=").concat(param.field);
    }
    if (param.value !== undefined) {
      searchQuery += "&searchCriteria[filter_groups][".concat(filtersGroupIndex, "][filters][").concat(filtersIndex, "][value]=").concat(param.value);
    }
    if (param.condition_type) {
      searchQuery += "&searchCriteria[filter_groups][".concat(filtersGroupIndex, "][filters][").concat(filtersIndex, "][condition_type]=").concat(param.condition_type);
    }
    if (param.sort_field) {
      searchQuery += "".concat(ampersand, "searchCriteria[sortOrders][").concat(filtersGroupIndex, "][direction]=").concat(param.direction);
    }
    if (param.direction) {
      searchQuery += "&searchCriteria[sortOrders][".concat(filtersGroupIndex, "][field]=").concat(param.sort_field);
    }
    if (param.search_phrase) {
      searchQuery += "".concat(ampersand, "searchCriteria[search_phrase]=").concat(param.search_phrase);
    }
    if (param.pageSize) {
      searchQuery += "".concat(ampersand, "searchCriteria[pageSize]=").concat(param.pageSize);
    }
    if (param.currentPage) {
      searchQuery += "".concat(ampersand, "searchCriteria[currentPage]=").concat(param.currentPage);
    }
    return searchQuery;
  }).join("");
};
exports.createSearchUrl = createSearchUrl;
var _default = createSearchUrl;
exports["default"] = _default;